// Edit-approval workflow for submitted documents: the owner asks to edit a
// locked document. Opened by the `requestDocumentEdit` row action
// (rowActionConfig, actionType "modal", allowMultiple) from both the list and
// the detail header, so one popup serves a single row and a bulk selection —
// the one reason typed here applies to every selected document.
export const config = {
  title: 'Request Document Edit',
  okText: 'Submit Request',
  cancelText: 'Cancel',
  width: 480,
  successMessage: 'Edit request submitted successfully.',
  fields: [
    {
      name: 'reason',
      label: 'Reason for Edit',
      type: 'textarea',
      required: true,
      rows: 4,
      maxLength: 1000,
      placeholder: 'Enter the reason for requesting changes to this document',
    },
  ],
};
